/**
 * WebAuthn credential management via our backend API.
 * Credentials are stored in DynamoDB and verified server-side.
 */

import { apiGet, apiPost, apiDelete } from '@/api/client';

export interface WebAuthnCredential {
  credentialId: string;
  friendlyName: string;
  deviceType: string;
  backedUp: boolean;
  createdAt: string;
  lastUsedAt: string;
}

export function getRegistrationOptions(): Promise<unknown> {
  return apiPost<unknown>('/account/webauthn/register-options', {});
}

export function verifyRegistration(body: { response: unknown; friendlyName: string }): Promise<{ credentialId: string }> {
  return apiPost<{ credentialId: string }>('/account/webauthn/register-verify', body);
}

export function listWebAuthnCredentials(): Promise<{ credentials: WebAuthnCredential[] }> {
  return apiGet<{ credentials: WebAuthnCredential[] }>('/account/webauthn/credentials');
}

export function deleteWebAuthnCredential(credentialId: string): Promise<void> {
  return apiDelete(`/account/webauthn/credentials/${encodeURIComponent(credentialId)}`);
}
